import React, { useEffect, useState, useReducer, useRef } from "react";
import { useFormikContext, Formik, Form, Field, useField } from "formik";
import { useSelector } from "react-redux";

import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Snackbar,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";

import {
  enviarLinkPruebaVida,
  obtenerCabeceraCliente,
} from "../services/creditoServices";

import {
  generarCapturaFirma,
  generarTokenBiometria,
} from "app/modules/app-cliente/services/clienteService";
import TabFirmaFotoCliente from "../containers/tabFirmaFotoCliente";
import {
  SCSGenericButton,
  SCSLoadingButton,
} from "app/modules/common/components/Buttons/SCSButtons";
import SCSAccordion from "app/modules/common/components/Accordions/SCSAccordion";

import "../styles/main.css";
import { sr } from "date-fns/locale";
import ModalHandleNotification from "app/modules/common/components/Modals/ModalHandleNotificaciones/ModalHandleNotification";
import {
  initialModalState,
  modalNotificacionReducer,
} from "app/modules/common/components/Modals/ModalHandleNotificaciones/modalNotificacionReducer";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const BoxPruebaVida = ({
  idCli,
  cliente,
  identifCliente,
  idSolicitudChanger,
  setInfoGrabada,
  infoGrabada,
  generaLink,
}) => {
  const { authUser } = useSelector(({ auth }) => auth);

  const [clienteInfo, setClienteInfo] = useState(null);
  const [idSolicitudActual, setIdSolicitudActual] = useState(null);
  const [datosEnviadosCorrectamente, setDatosEnviadosCorrectamente] =
    useState(false);
  const [alertaGuardar, setAlertaGuardar] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [generoLink, setGeneroLink] = useState(false);
  const [token, setToken] = useState("");

  const allowShowHelpRef = useRef(false);
  // Cuando quieras cambiar el valor:
  const setAllowShowHelp = (value) => {
    allowShowHelpRef.current = value;
    // Si necesitas que esto afecte también a la UI (pantalla),
    // mantén el useState paralelo, pero usa el ref para la lógica del timer
  };
  //const [open, setOpen] = useState(false);

  const [modalState, modalDispatch] = useReducer(
    modalNotificacionReducer,
    initialModalState,
  );
  const urlPasarela = process.env.REACT_APP_WEB_PASARELA;
  useEffect(() => {
    console.log("USUARIO EN FIRMA", identifCliente);
    //console.log("AQUI", authUser);
    getInformacionCliente(idCli);
  }, []);

  const getInformacionCliente = async (idCliente) => {
    await obtenerCabeceraCliente(idCliente)
      .then((response) => {
        //console.log(response);
        if (response.state) {
          setClienteInfo(response.data);
        } else console.log(response.message);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const configuracionDatosEnvioCliente = async (values) => {
    setLoading(true);
    allowShowHelpRef.current = true;

    if (clienteInfo.celular != "") {
      try {
        console.log("Envio de peticion de firma al backend");

        const datos = {
          idCliente: idCli,
          idGrupo: authUser.usuarioFlujos[0].idGrupo,
          usuario: authUser.key,
          host: authUser.estacion,
          origen: "SCS",
          transaccion: "REGISTRO",
          celular: clienteInfo.celular,
          nombre: clienteInfo.primerNombre,
        };
        const srvToken = await generarTokenBiometria(datos);

        if (srvToken.state) {
          console.log("Token generado", srvToken.data);
          setGeneroLink(true);
          setDatosEnviadosCorrectamente(true);
          setToken(srvToken.data);
          if (setInfoGrabada) {
            setInfoGrabada((args) => ({
              ...args,
              firma: true,
            }));
          }
          console.log(allowShowHelpRef.current);
          setLoading(false);

          //ENVIA LINK

          try {
            const urlBasePV =encodeURIComponent(`signature/${srvToken.data}?Tipo=REGISTRO&Origen=SCS`);

            const srvEnvioLink = await enviarLinkPruebaVida(
              idCli,
              clienteInfo.identificacion,
              clienteInfo.celular,
              urlBasePV,
              authUser.usuarioFlujos[0].idGrupo
            );
          } catch (e) {
            console.log("Error al enviar el link de firma", e);
          }
          // setTimeout(() => {
          //   // setLoading(false);
          //   // setOpen(false);
          //   //handleClose();
          //   //setDatosEnviadosCorrectamente(false);
          //   console.log(allowShowHelpRef.current);

          //   if (allowShowHelpRef.current) {
          //     modalDispatch({
          //       type: "SHOW_WARNING",
          //       title: "¿Necesitas una mano con tu firma digital?",
          //       // message:"Queremos que el proceso sea sencillo para ti, así que no te preocupes, ¡lo solucionaremos juntos! Puedes contactarnos de inmediato por estos medios:Chat en vivo: [Insertar enlace]Línea de atención: [Insertar número]",
          //       message: (
          //         <Box textAlign="center">
          //           <Typography>
          //             Queremos que el proceso sea sencillo para ti, así que no
          //             te preocupes, ¡lo solucionaremos juntos!
          //             <br />
          //             <br />
          //             Puedes contactarnos de inmediato por estos medios:
          //           </Typography>

          //           {/* Contenedor centrado para el icono y el link */}
          //           <Box
          //             display="flex"
          //             justifyContent="center"
          //             alignItems="center"
          //             gap={1}
          //             my={1}
          //           >
          //             <WhatsAppIcon style={{ color: "#25D366" }} />{" "}
          //             {/* Icono de WhatsApp */}
          //             <Typography component="span">Chat en vivo:</Typography>
          //             <Link
          //               href="https://wa.me/593998960000?text=Hola%20Servimax,%20necesito%20ayuda%20con%20mi%20prueba%20de%20vida."
          //               target="_blank"
          //               rel="noopener"
          //               sx={{
          //                 color: "red",
          //                 fontWeight: "bold",
          //                 fontSize: "1.1rem",
          //               }}
          //             >
          //               CLICK AQUÍ
          //             </Link>
          //           </Box>

          //           <Typography>Línea de atención: 023811960</Typography>
          //         </Box>
          //       ),
          //       urlRoute: true,
          //     });
          //   }
          // }, 30000);
        } else {
          console.log(srvToken.message);
        }
      } catch (error) {
        console.log("Error al generar el token", error);
      }
    } else {
      setMensajeError(
        "No se encuentra un celular registrado en la informacion de cliente",
      );
      setAlertaGuardar(true);

      setTimeout(() => {
        setAlertaGuardar(false);
      }, 5000);
    }
  };

  const configuracionDatosAbrirValidacion = async (values) => {
    setLoading(true);
    allowShowHelpRef.current = true;

    if (clienteInfo.celular != "") {
      try {
        console.log("Envio de peticion de firma al backend");

        const datos = {
          idCliente: idCli,
          idGrupo: authUser.usuarioFlujos[0].idGrupo,
          usuario: authUser.key,
          host: authUser.estacion,
          origen: "SCS",
          transaccion: "REGISTRO",
          celular: clienteInfo.celular,
          nombre: clienteInfo.primerNombre,
        };
        const srvToken = await generarTokenBiometria(datos);

        if (srvToken.state) {
          console.log("Token generado", srvToken.data);
          setOpen(true);
          setGeneroLink(true);
          setDatosEnviadosCorrectamente(true);
          setToken(srvToken.data);
          if (setInfoGrabada) {
            setInfoGrabada((args) => ({
              ...args,
              firma: true,
            }));
          }
          console.log(allowShowHelpRef.current);

          setTimeout(() => {
            // setLoading(false);
            // setOpen(false);
            //handleClose();
            //setDatosEnviadosCorrectamente(false);
            console.log(allowShowHelpRef.current);

            if (allowShowHelpRef.current) {
              modalDispatch({
                type: "SHOW_WARNING",
                title: "¿Necesitas una mano con tu firma digital?",
                // message:"Queremos que el proceso sea sencillo para ti, así que no te preocupes, ¡lo solucionaremos juntos! Puedes contactarnos de inmediato por estos medios:Chat en vivo: [Insertar enlace]Línea de atención: [Insertar número]",
                message: (
                  <Box textAlign="center">
                    <Typography>
                      Queremos que el proceso sea sencillo para ti, así que no
                      te preocupes, ¡lo solucionaremos juntos!
                      <br />
                      <br />
                      Puedes contactarnos de inmediato por estos medios:
                    </Typography>

                    {/* Contenedor centrado para el icono y el link */}
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      gap={1}
                      my={1}
                    >
                      <WhatsAppIcon style={{ color: "#25D366" }} />{" "}
                      {/* Icono de WhatsApp */}
                      <Typography component="span">Chat en vivo:</Typography>
                      <Link
                        href="https://wa.me/593998960000?text=Hola%20Servimax,%20necesito%20ayuda%20con%20mi%20prueba%20de%20vida."
                        target="_blank"
                        rel="noopener"
                        sx={{
                          color: "red",
                          fontWeight: "bold",
                          fontSize: "1.1rem",
                        }}
                      >
                        CLICK AQUÍ
                      </Link>
                    </Box>

                    <Typography>Línea de atención: 023811960</Typography>
                  </Box>
                ),
                urlRoute: true,
              });
            }
          }, 90000);
        } else {
          console.log(srvToken.message);
        }
      } catch (error) {
        console.log("Error al generar el token", error);
      }
    } else {
      setMensajeError(
        "No se encuentra un celular registrado en la informacion de cliente",
      );
      setAlertaGuardar(true);

      setTimeout(() => {
        setAlertaGuardar(false);
      }, 5000);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      //console.log(reason);
      setOpen(true);
    } else {
      setOpen(false);
      setLoading(false);
    }

    allowShowHelpRef.current = false;
  };

  if (idCli < 0) {
    return <h2>Debe crear primero un cliente !!</h2>;
  }

  const MasInformacionDocumentos = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 1,
          p: 1,
          width: "100%",
        }}
      >
        <Typography variant="h2" fontWeight="bold">
          Confirma que eres tu.
        </Typography>

        <Typography variant="p" color="text.secondary">
          Realiza una breve verificación facial para validar tu identidad de
          forma rápida y segura.
        </Typography>
      </Box>
    );
  };
  return (
    <>
      <SCSAccordion
        tituloCabecera="Confirma tu identidad"
        tieneInfo={true}
        componenteInformacion={<MasInformacionDocumentos />}
      >
        <Formik
          initialValues={{}}
          onSubmit={(values, { setSubmitting }) => {
            // console.log(values);
            //configuracionDatosEnvio(values);
          }}
        >
          {({ values, handleChange }) => (
            <Form>
              {/* Informacion de solicitud */}
              {generaLink ? (
                <Stack alignItems="center">
                  <SCSGenericButton
                    loading={loading}
                    titulo=".   Enviar prueba de vida a celular   ."
                    onClick={() => configuracionDatosEnvioCliente(values)}
                  />
                  {generoLink && (
                    <Alert sx={{ mt: 2 }} severity="success">
                      Ha realizado la prueba de vida correctamente puede
                      continuar.
                    </Alert>
                  )}
                </Stack>
              ) : (
                <Stack alignItems="center">
                  <SCSGenericButton
                    loading={loading}
                    titulo=".   Iniciar proceso de Validacion de Identidad   ."
                    onClick={() => configuracionDatosAbrirValidacion(values)}
                  />
                  {generoLink && (
                    <Alert sx={{ mt: 2 }} severity="success">
                      Ha realizado la prueba de vida correctamente puede
                      continuar.
                    </Alert>
                  )}
                </Stack>
              )}
              {/* <Button type="submit" className="link-boton-firma">
                  <img
                    src={"/images/logo/FirmaDigital.png"}
                    alt="boton firma digital"
                  />
                  Generar petición de firma digital en dispositivo de Cliente 
                </Button> */}
              {/* <Snackbar
                open={open}
                autoHideDuration={5000}
                onClose={handleClose}
              >
                <Alert
                  variant="filled"
                  onClose={handleClose}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                  El link se ha enviado a su whatsapp
                </Alert>
              </Snackbar> */}
              {alertaGuardar && (
                <Alert severity="error" variant="filled">
                  {mensajeError}
                </Alert>
              )}
            </Form>
          )}
        </Formik>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            Confirma que eres tu y realiza la validacion facial de tu identidad.
          </DialogTitle>
          <DialogContent sx={{ p: 0, height: "100%" }}>
            {token !== "" && (
              <iframe
                key={token}
                src={`${urlPasarela}signature/${token}?Tipo=REGISTRO&Origen=SCS`}
                // src={`https://0b627xp0-5173.use.devtunnels.ms/signature/${token}`}
                // src={`${process.env.REACT_APP_WEB_PASARELA}/signature/${token}`}
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: "100vh" }}
                title="Firma digital"
                // Esto es vital para iOS:
                allow="camera *; microphone *; display-capture *; geolocation *; midi *;"
                // Agrega esto para evitar que Safari bloquee la ejecución por seguridad de origen:
                allowFullScreen
                // Permite que la interacción se maneje correctamente en iOS:
                sandbox="allow-forms allow-scripts allow-same-origin allow-modals allow-popups allow-presentation"
              ></iframe>
            )}
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </SCSAccordion>
      <ModalHandleNotification
        parameters={modalState}
        setOpen={() => modalDispatch({ type: "CLOSE_MODAL" })}
      />
    </>
  );
};

export default BoxPruebaVida;
